import React, { useState, Fragment, useEffect } from 'react';
import Select from 'react-select';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Label,
  Input,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import country from '../../../../../../data/country';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
  faRandom,
  faAssistiveListeningSystems,
  faDharmachakra,
  faVihara,
  faGlobe,
  faFlag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';

function TriggerResponse({
  reloadBotResponse,
  elem,
  trigger,
  dialogIndex,
  dialogUpdate,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'All',
  });
  const [regex, setRegex] = useState(
    trigger === undefined || trigger.regex === undefined ? '' : trigger.regex
  );
  const [domain, setDomain] = useState(
    trigger === undefined || trigger.domain === undefined ? '' : trigger.domain
  );
  const [luis, setLuis] = useState(
    trigger === undefined || trigger.luis === undefined ? '' : trigger.luis
  );
  const [postData, setPostData] = useState(elem);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleSave = () => {
    const data = { ...postData };
    if (regex !== '') {
      data.triggers.regex = regex;
    } else {
      if (data.triggers.regex) {
        delete data.triggers.regex;
      }
    }
    if (luis !== '') {
      data.triggers.luis = luis;
    } else {
      if (data.triggers.luis) {
        delete data.triggers.luis;
      }
    }
    if (domain !== '') {
      data.triggers.domain = domain;
    } else {
      if (data.triggers.domain) {
        delete data.triggers.domain;
      }
    }
    if (selectedCountry.value !== '') {
      data.triggers.country = selectedCountry.value;
    } else {
      if (data.triggers.country) {
        delete data.triggers.country;
      }
    }
    console.log(data);
    dialogUpdate(data, dialogIndex);
    setIsEditing(false);
  };
  const handleRegexChange = (e) => {
    setRegex(e.target.value);
  };
  const handleDomainChange = (e) => {
    setDomain(e.target.value);
  };
  const handleLuisChange = (e) => {
    setLuis(e.target.value);
  };
  const handleCancel = () => {
    setIsEditing(false);
    // const data = { ...postData };
    // data.messages[codeIndex].apiCode = apiCode;
    // setPostData(data);
    // setMessageInput(apiCode);
  };
  const handleChangeSelect = (value, { name }) => {
    setSelectedCountry(value);
  };
  useEffect(() => {
    if (trigger !== undefined && trigger.country !== undefined) {
      const countryGroup = country.filter(
        (item) => item.code === trigger.country
      );
      let countrySelected = {
        value: countryGroup[0].code,
        label: countryGroup[0].name,
      };
      setSelectedCountry(countrySelected);
    }
  }, [elem]);
  return (
    <Card className="mb-2">
      <CardBody>
        {!isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row className="mb-2">
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faRandom} />
                  <span> </span>
                  Triggers
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                  </div>
                </Colxx>
              </Row>
              {trigger && (
                <Row>
                  <Colxx xxs="12">
                    {trigger.complex && (
                      <Fragment>
                        <p className="mb-2">
                          {' '}
                          <FontAwesomeIcon icon={faVihara} />
                          <span> </span>
                          <b>Complex:</b>
                        </p>
                        {trigger.complex.map((complex, index) => {
                          return (
                            <div className="mb-2">
                              <b>Type:</b> {complex.type}{' '}
                              {complex.intents && (
                                <Fragment>
                                  <b>Intents:</b> {complex.intents}
                                </Fragment>
                              )}{' '}
                              {complex.minScore && (
                                <Fragment>
                                  <b>Min Score:</b> {complex.minScore}
                                </Fragment>
                              )}
                            </div>
                          );
                        })}
                        <p>
                          {' '}
                          {trigger.complexPriority && (
                            <Fragment>
                              <b>Priority:</b> {trigger.complexPriority}
                            </Fragment>
                          )}{' '}
                        </p>
                      </Fragment>
                    )}
                    {trigger.regex && (
                      <p>
                        <FontAwesomeIcon icon={faDharmachakra} />
                        <span> </span>
                        <b>Regex:</b> {trigger.regex}{' '}
                      </p>
                    )}
                    {trigger.luis && (
                      <p>
                        {' '}
                        <FontAwesomeIcon icon={faAssistiveListeningSystems} />
                        <span> </span>
                        <b>LUIS:</b> {trigger.luis}{' '}
                      </p>
                    )}
                    {trigger.domain && (
                      <p>
                        <FontAwesomeIcon icon={faGlobe} />
                        <span> </span>
                        <b>Domain:</b> {trigger.domain}{' '}
                      </p>
                    )}
                    {trigger.country && (
                      <p>
                        <FontAwesomeIcon icon={faFlag} />
                        <span> </span>
                        <b>Country:</b> {trigger.country}{' '}
                      </p>
                    )}
                  </Colxx>
                </Row>
              )}
            </CardTitle>{' '}
          </Fragment>
        ) : (
          <CardTitle>
            <Row className="mb-2">
              <Colxx xxs="6">
                <FontAwesomeIcon icon={faRandom} />
                <span> </span>
                Triggers
              </Colxx>
              <Colxx xxs="6">
                <div className="float-right">
                  <Button
                    color="primary"
                    className="add-button"
                    size="xs"
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <b> </b>
                  <Button
                    color="secondary"
                    className="add-button"
                    size="xs"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </Colxx>
            </Row>
            <Row className="mb-2">
              <Colxx xxs="2">
                <Label>Regex</Label>
              </Colxx>
              <Colxx xxs="3">
                <Input
                  type="text"
                  name="regex"
                  value={regex}
                  onChange={handleRegexChange}
                ></Input>
              </Colxx>
              <Colxx xxs="1">
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ color: 'var(--theme-color-1)' }}
                  cursor="pointer"
                  onClick={() => {
                    setRegex('');
                  }}
                />
              </Colxx>

              <Colxx xxs="2">
                <Label>NLP Intent</Label>
              </Colxx>
              <Colxx xxs="3">
                <Input
                  type="text"
                  name="luis"
                  value={luis}
                  onChange={handleLuisChange}
                ></Input>
              </Colxx>
              <Colxx xxs="1">
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ color: 'var(--theme-color-1)' }}
                  cursor="pointer"
                  onClick={() => {
                    setLuis('');
                  }}
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="2">
                <Label>Domain</Label>
              </Colxx>
              <Colxx xxs="3">
                <Input
                  type="select"
                  value={domain}
                  name="type"
                  onChange={handleDomainChange}
                >
                  <option value="">All</option>
                  <option value="AccommodationProviders">
                    Accommodation Providers
                  </option>
                  <option value="Lawnmowers">Lawnmowers</option>
                  <option value="Electricians">Electricians</option>
                  <option value="Coaching">Coaching</option>
                  <option value="Retail">Retail</option>
                  <option value="Covid">Covid</option>
                  <option value="Smalltalk">Smalltalk</option>
                  <option value="RetirementHomes">Retirement Homes</option>
                  <option value="Salons">Salons</option>
                  <option value="SalonsSmallTalk">Salons SmallTalk</option>
                  <option value="HolidaysPark">Holidays Park</option>
                  <option value="QuarantineBot">Quarantine Bot</option>
                  <option value="HolidayHomes">Holiday Homes</option>
                  <option value="VirtualVetNurse">Virtual Vet Nurse</option>
                  <option value="Tourism">Tourism</option>
                  <option value="Doctors">Doctors</option>
                  <option value="Northable">Northable</option>
                  <option value="Golf">Golf</option>
                  <option value="BusinessOperator">Business Operator</option>
                  <option value="Activities">Activities</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="UtilityProviders">Utility Providers</option>
                </Input>
              </Colxx>
              <Colxx xxs="1">
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ color: 'var(--theme-color-1)' }}
                  cursor="pointer"
                  onClick={() => {
                    setDomain('');
                  }}
                />
              </Colxx>
              <Colxx xxs="2">
                <Label>Country</Label>
              </Colxx>
              <Colxx xxs="3">
                <Select
                  isMulti={false}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="code"
                  placeholder="Select Country"
                  onChange={handleChangeSelect}
                  value={selectedCountry}
                  options={
                    country
                      ? reactSelectOptionDiffrentPro(
                        country,
                        true,
                        'code',
                        'name',
                        ''
                      )
                      : []
                  }
                />
              </Colxx>
              <Colxx xxs="1">
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ color: 'var(--theme-color-1)' }}
                  cursor="pointer"
                  onClick={() => {
                    setSelectedCountry({
                      value: '',
                      label: 'Please Select',
                    });
                  }}
                />
              </Colxx>
            </Row>
          </CardTitle>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(TriggerResponse));
